<script lang="ts" module>
  import type { ButtonProps } from "../button/Button.svelte"

  // variant is optional here: DialogClose supplies its own default.
  export type DialogCloseProps = Omit<ButtonProps, "variant"> & {
    variant?: ButtonProps["variant"]
  }
</script>

<script lang="ts">
  import { cn } from "#lib/utils"
  import { Close } from "@tastyworks/icons"
  import Button from "../button/Button.svelte"
  import { getDialogRootContext } from "./DialogRoot.svelte"

  const rootCtx = getDialogRootContext()

  let {
    class: cssClass = "",
    variant = "ghostPrimary",
    size = "large",
    onclick,
    use = [],
    children,
    ...restProps
  }: DialogCloseProps = $props()

  // [Claude] Attaches the click handler directly via addEventListener rather than passing
  // onclick through props. Event handlers spread onto <svelte:element> in Button
  // don't fire reliably with programmatic clicks (e.g. Playwright e2e tests).
  function closeAction(node: HTMLElement) {
    function handleClick(e: MouseEvent) {
      $rootCtx = { ...$rootCtx, open: false }
      ;(onclick as ((e: MouseEvent) => void) | undefined)?.(e)
    }
    node.addEventListener("click", handleClick)
    return {
      destroy() {
        node.removeEventListener("click", handleClick)
      },
    }
  }
</script>

<Button
  class={cn(
    "flex items-center justify-center",
    !children && "text-icon-general-primary size-6 p-0",
    cssClass
  )}
  {variant}
  {size}
  aria-label={children ? undefined : "Close"}
  use={[closeAction, ...use]}
  {...restProps}
>
  {#if children}
    {@render children()}
  {:else}
    <Close class="size-6" />
  {/if}
</Button>
